import React from 'react'
import { Form, Text } from 'components/forms'
import prepareMutationData from './prepareMutationData'
import { Col } from 'react-flexbox-grid'
import Divider from 'components/Divider'
import { appConfig } from 'gql/query'
import { useQuery } from 'components/graphql'

const Accounting = ({ data, updateMutation, disabled }) => {
	useQuery(appConfig.pointsSystem)
	
	const handleSubmit = (vals, category) => {
		if(vals) {
			const mutationData = prepareMutationData(vals?.[category], category, data?.[category]?.map(el => el.originalIndex))
			mutationData && updateMutation(mutationData)
		}
	}

	const fields = (category) => {
		const cols = []
		const inputData = data?.[category] || []

		inputData.forEach((row, i) => {
			cols.push(
				<Text
					key={`${row.label}_${i}`}
					field={`[${category}][${i}].value`}
					label={row.label}
					disabled={disabled && category !== 'creditCards'}
				/>
			)
		})

		return cols
	}

	return(
		<>
			<Col xs={5}>
				<Form
					initialValues={data}
					onSubmit={(e) => handleSubmit(e, 'general')}
					smartSubmit
				>
					{() => fields('general')}
				</Form>
				<Divider/>
				<Form
					initialValues={data}
					onSubmit={(e) => handleSubmit(e, 'accountPrepaidCard')}
					smartSubmit
				>
					{() => fields('accountPrepaidCard')}
				</Form>
				<Divider/>
				<Form
					initialValues={data}
					onSubmit={(e) => handleSubmit(e, 'salesNames')}
					smartSubmit
				>
					{() => fields('salesNames')}
				</Form>
			</Col>
			<Col xs={5}>
				<Form
					initialValues={data}
					onSubmit={(e) => handleSubmit(e, 'creditCards')}
					smartSubmit
				>
					{() => fields('creditCards')}
				</Form>
			</Col>
		</>
	)
}

export default Accounting
